module.exports = __webpack_public_path__ + "static/media/takeOut.b45547c8.pdf";